var map = {
	"./index": 10,
	"./index.js": 10,
	"./zh-cn": 35,
	"./zh-cn.js": 35,
	"./zh-cn/buttons": 36,
	"./zh-cn/buttons.js": 36,
	"./zh-cn/datetime": 37,
	"./zh-cn/datetime.js": 37,
	"./zh-cn/validation": 38,
	"./zh-cn/validation.js": 38
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 229;



/*****************
 ** WEBPACK FOOTER
 ** ./src/lang ^\.\/.*$
 ** module id = 229
 ** module chunks = 0
 **/